// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#pai {
    width: 94%;
}
/* ---------------------------------------------------
    TABELA
----------------------------------------------------- */

.tabela {
    overflow-y: scroll;
    margin: 0 -15% 0% 4%;
    height: 365px;
    text-align: center;
    width: 111%;
 
}

th {
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    background: #007bff;
    color:  white;
}

@media only screen and (max-width: 768px) {    
    .tabela {
        margin: 0 -15% 0% 3%;
        width: 111%;
    }




}

/* ---------------------------------------------------
    CARD
----------------------------------------------------- */



.title-card {
    font-weight: bold;
    margin: 5% 0 5% 5%
}

.cardFornecedor {
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2PX rgba(0,0,0,0.20);
    margin: 0 0% 5% 2%;
    width: 110%;
}

@media only screen and (max-width: 768px) {
    .title-card {
        font-weight: bold;
        margin: 5% 0 5% 5%
    }
    
    .cardFornecedor {
        width: 111%;
        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2PX rgba(0,0,0,0.20);
        margin: 0 0% 5% 3%;
    }
}

/* ---------------------------------------------------
    INPUTS
----------------------------------------------------- */

#data {
    background-color: transparent;
    border: none;
    border-bottom: 1px solid black;
    border-radius: 0;
    outline: none;
    height: 2rem;
    width: 100%;
    font-size: 1rem;
    margin: 0 2% 0 15%;
    padding: 0;
    box-shadow: none;
    box-sizing: content-box;
    transition: all 0.3s;
}

#data1 {
    background-color: transparent;
    border: none;
    border-bottom: 1px solid black;
    border-radius: 0;
    outline: none;
    height: 2rem;
    width: 100%;
    font-size: 1rem;
    margin: 0 2% 0 8%;
    padding: 0;
    box-shadow: none;
    box-sizing: content-box;
    transition: all 0.3s;
}

#dateInput {
    width: 30%;
}

#dateInput1 {
    width: 30%;
}

@media only screen and (max-width: 768px) {
    #dateInput {
        width: 50%;
        padding-right: 0%;
        margin-bottom: 4%;
    }

    #dateInput1 {
        width: 50%;
        padding-right: 0%;
        margin-bottom: 4%;
    }
    
    #data {
        border-style: hidden hidden solid hidden;
        width: 90%;
        margin-left: 10%;
        padding: 0%;
        position: relative;
    }
    
    #data1 {
        border-style: hidden hidden solid hidden;
        margin-left: 10%;
        width: 90%;
        padding: 0%;
        position: relative;
    }

    #data1 .react-datepicker-ignore-onclickoutside .react-datepicker-popper {
        left: -94px;
        position: absolute;
    }
}


/* ---------------------------------------------------
    INPUTS POR CODIGO GERAL/POR ITEM GERAL
----------------------------------------------------- */


.revistaLabel {
    margin: 0 0 0 7%;
}

#revista {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 47%;
    margin: 0 0 0 7%;
    border-bottom: 1px solid black;
    font-size: 2vh;
}

@media only screen and (max-width: 768px) {
    .revistaLabel {
        margin: 0 0 0 6%;
    }
    
    #revista {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }
}

/* ---------------------------------------------------
    INPUTS POR ITEM TAMANHOS
----------------------------------------------------- */


.revistaLabel2 {
    margin: 0 2% 0 15%;
}

#revista2 {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 100%;
    margin: 0 0 0 15%;
    border-bottom: 1px solid black;
    font-size: 2vh;
}

.referenciaLabel2 {
    margin: 2% 2% 0 10%;
}

#referencia2 {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 100%;
    margin: 0 0 0 8%;
    border-bottom: 1px solid black;
}

@media only screen and (max-width: 768px) {
    .revistaLabel2 {
        margin: 0 2% 0 6%;
    }
    
    #revista2 {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }
    
    .referenciaLabel2 {
        margin: 0 0% 0 6%;
    }
    
    #referencia2 {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }
}

/* ---------------------------------------------------
    INPUTS POR ITEM LOJA
----------------------------------------------------- */


.revistaLabel3 {
    margin: 0 2% 0 15%;
}

#revista3 {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 100%;
    margin: 0 0 0 15%;
    border-bottom: 1px solid black;
    font-size: 2vh;
}

.referenciaLabel3 {
    margin: 2% 2% 0 10%;
}

#referencia3 {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 100%;
    margin: 0 0 0 8%;
    border-bottom: 1px solid black;
}


@media only screen and (max-width: 768px) {
    .revistaLabel3 {
        margin: 0 2% 0 6%;
    }
    
    #revista3 {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }
    
    .referenciaLabel3 {
        margin: 0 0% 0 6%;
    }
    
    #referencia3 {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }
}

/* ---------------------------------------------------
    INPUTS ACUMULADO POR LOJA
----------------------------------------------------- */


.revistaLabel4 {
    margin: 0 2% 0 15%;
}

#revista4 {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 100%;
    margin: 0 0 0 15%;
    border-bottom: 1px solid black;
    font-size: 2vh;
}

@media only screen and (max-width: 768px) {
    .revistaLabel4 {
        margin: 0 2% 0 6%;
    }
    
    #revista4 {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }
}

/* ---------------------------------------------------
    INPUTS POR CODIGO E LOJA
----------------------------------------------------- */


.revistaLabel5 {
    margin: 0 2% 0 15%;
}

#revista5 {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 100%;
    margin: 0 0 0 15%;
    border-bottom: 1px solid black;
    font-size: 2vh;
}

.revistaLabel6 {
    margin: 0 2% 0 10%;
}

#revista6 {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 98%;
    margin: 0 0 0 10%;
    border-bottom: 1px solid black;
    font-size: 2vh;
}

@media only screen and (max-width: 768px) {
    .revistaLabel5 {
        margin: 0 2% 0 6%;
    }
    
    #revista5 {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }

    .revistaLabel6 {
        margin: 0 2% 0 6%;
    }
    
    #revista6 {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }
}

/* ---------------------------------------------------
    INPUTS POR CODIGO LOJA
----------------------------------------------------- */


.revistaLabel7 {
    margin: 0 2% 0 15%;
}

#revista7 {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 100%;
    margin: 0 0 0 15%;
    border-bottom: 1px solid black;
    font-size: 2vh;
}

.revistaLabel8 {
    margin: 0 2% 0 15%;
}

#revista8 {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 100%;
    margin: 0 0 0 10%;
    border-bottom: 1px solid black;
    font-size: 2vh;
}

.revistaLabel9 {
    margin: 0 2% 0 15%;
}

#revista9 {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 100%;
    margin: 0 0 0 15%;
    border-bottom: 1px solid black;
}

@media only screen and (max-width: 768px) {
    .revistaLabel7 {
        margin: 0 2% 0 6%;
    }
    
    #revista7 {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }

    .revistaLabel8 {
        margin: 0 2% 0 6%;
    }
    
    #revista8 {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }

    .revistaLabel9 {
        margin: 0 2% 0 6%;
    }
    
    #revista9 {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }
}

/* ---------------------------------------------------
    INPUTS POR CODIGO LOJA
----------------------------------------------------- */


.revistaLabel10 {
    margin: 0 2% 0 15%;
}

#revista10 {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 100%;
    margin: 0 0 0 15%;
    border-bottom: 1px solid black;
    font-size: 2vh;
}

@media only screen and (max-width: 768px) {
    .revistaLabel10 {
        margin: 0 2% 0 6%;
    }
    
    #revista10 {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 98%;
        margin: 0 0 0 6%;
    }

}

/* ---------------------------------------------------
    BUTTON LIMPAR
----------------------------------------------------- */

div .buttonLimpar {
    margin: 0% 0% 0% 15%;
    width: 100%;
    position: relative;
    padding-top: 1%;
    background:white;
    border-radius: 0%;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2);
    border: none;     
    color: #007bff;
}


div .buttonLimpar:hover {
    background: #007bff;
    color:  white;
}

div .buttonLimpar:focus {
    background: #007bff;
    color: white;
}


@media only screen and (max-width: 768px) {
    div .buttonLimpar {
        padding: 0% 0% 0% 0%;
        width: 100%;
        position: relative;
        margin:0% 0% 0% 5%;
        padding-top: 1%;
        background: white;
        border-radius: 0%;
        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2);
        border: none;
        color: #007bff;
    }
}

/* ---------------------------------------------------
    BUTTON FILTRAR
----------------------------------------------------- */

div .buttonFiltrar  {
    padding: 0% 0% 2,5% 0%;
    position: relative;
    margin: 0% 0% 0% 15%;
    width: 100%;
    padding-top: 1%;
    background: #007bff;
    border-radius: 0%;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2);
    border: none;
}

div .buttonFiltrar:hover {
    background: white;
    color: #007bff;
}


div .buttonFiltrar:focus {
    background: white;
    color: #007bff;
}



@media only screen and (max-width: 768px) {
    div .buttonFiltrar {
        padding: 2% 0;
        width: 102%;
        position: relative;
        margin:0% 0% 0% 5%;
        padding-top: 1%;
        background: #007bff;
        border-radius: 0%;
        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2); 
        border: none;
    }
}

/* ---------------------------------------------------
    BUTTON IMPRIMIR
----------------------------------------------------- */

.buttonImprimir {
    padding: 0% 0% 0% 0%;
    width: 100%;
    margin: 0% 0% 0% 15%;
    position: relative;
}



div .buttonImprimir {
    padding-top: 1%;
    background: #007bff;
    border-radius: 0%;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2);
    border: none;	
    margin: 0% 0% 0% 8%;
}

div .buttonImprimir:hover {
    background: white;
    color: #007bff;
}


div .buttonImprimir:focus {
    background: white;
    color: #007bff;
}



@media only screen and (max-width: 768px) {
    div .buttonImprimir {
        background: #007bff;
        border-radius: 0%;
        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2); 
        border: none;
        padding: 2% 0;
        margin: 0% 0% 0% 5%;
    }

    .buttonImprimir {
        padding: 0% 0% 0% 0%;
        width: 102%;
        position: relative;
    }
}

/* ---------------------------------------------------
    BUTTON BAIXAR
----------------------------------------------------- */

#test-table-xls-button {
    padding: 4% 0%;
    width: 100%;
    position: relative;
    margin:0% 2% 0% 15%;
}

div #test-table-xls-button {
    padding-top: 1%;
    background: #007bff;
    color: white;
    border-radius: 0%;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2);
    border: none;	
}

div #test-table-xls-button:hover {
    background: white;
    color: #007bff;
}


div #test-table-xls-button:focus {
    background: white;
    color: #007bff;
}



@media only screen and (max-width: 768px) {
    div #test-table-xls-button {
        padding: 2% 0;
        background: #007bff;
        border-radius: 0%;
        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2); 
        border: none;
        color: white
    }

    #test-table-xls-button {
        padding: 0% 0% 0% 0%;
        margin:0% 0% 0% 5%;
        width: 102%;
        position: relative;
    }
    
}





.hide {
 display: none;
}

#formselect{
    padding: 4px 4px 4px 4px;
    width: 100%;
}

.enter{
   margin: 5% 0% 0% 0%;
}

.centrocentro{
    text-align-last: center;
  
}


/* ---------------------------------------------------
    Select Tabela
----------------------------------------------------- */


.labelSelect {
    font-weight: bold;
    font-size: 22px;
}

#select {
    border-style: hidden hidden solid hidden;
    border-radius: 0%;
    width: 25%;
}

@media only screen and (max-width: 768px) {
    #select {
        border-style: hidden hidden solid hidden;
        border-radius: 0%;
        width: 80%;
    }
}

.silas{
    background: #007bff;
    color: white;
}


.alinhamento{
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/MetasVendedoras/metasvend.css"],"names":[],"mappings":";AACA;IACI,UAAU;AACd;AACA;;uDAEuD;;AAEvD;IACI,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,kBAAkB;IAClB,WAAW;;AAEf;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,MAAM;IACN,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI;QACI,oBAAoB;QACpB,WAAW;IACf;;;;;AAKJ;;AAEA;;uDAEuD;;;;AAIvD;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,uGAAuG;IACvG,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,WAAW;QACX,uGAAuG;QACvG,kBAAkB;IACtB;AACJ;;AAEA;;uDAEuD;;AAEvD;IACI,6BAA6B;IAC7B,YAAY;IACZ,8BAA8B;IAC9B,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,8BAA8B;IAC9B,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,UAAU;QACV,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,UAAU;QACV,gBAAgB;QAChB,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,wCAAwC;QACxC,gBAAgB;QAChB,UAAU;QACV,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ;;;AAGA;;uDAEuD;;;AAGvD;IACI,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;AACJ;;AAEA;;uDAEuD;;;AAGvD;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;AACJ;;AAEA;;uDAEuD;;;AAGvD;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,8BAA8B;AAClC;;;AAGA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;AACJ;;AAEA;;uDAEuD;;;AAGvD;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;AACJ;;AAEA;;uDAEuD;;;AAGvD;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,UAAU;IACV,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;AACJ;;AAEA;;uDAEuD;;;AAGvD;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;AACJ;;AAEA;;uDAEuD;;;AAGvD;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;QACV,gBAAgB;IACpB;;AAEJ;;AAEA;;uDAEuD;;AAEvD;IAEI,oBAAoB;IACpB,WAAW;IACX,kBAAkB;IAIlB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sGAAsG;IACtG,YAAY;IACZ,cAAc;AARlB;;;AAYA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;;AAGA;IACI;QACI,oBAAoB;QACpB,WAAW;QACX,kBAAkB;QAClB,kBAAkB;QAIlB,eAAe;QACf,iBAAiB;QACjB,iBAAiB;QACjB,sGAAsG;QACtG,YAAY;QACZ,cAAc;IARlB;AAUJ;;AAEA;;uDAEuD;;AAEvD;IACI,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;IAKX,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,sGAAsG;IACtG,YAAY;AARhB;;AAWA;IACI,iBAAiB;IACjB,cAAc;AAClB;;;AAGA;IACI,iBAAiB;IACjB,cAAc;AAClB;;;;AAIA;IACI;QACI,aAAa;QACb,WAAW;QACX,kBAAkB;QAClB,kBAAkB;QAIlB,eAAe;QACf,mBAAmB;QACnB,iBAAiB;QACjB,sGAAsG;QACtG,YAAY;IAPhB;AASJ;;AAEA;;uDAEuD;;AAEvD;IACI,oBAAoB;IACpB,WAAW;IACX,oBAAoB;IACpB,kBAAkB;AACtB;;;;AAIA;IACI,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,sGAAsG;IACtG,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;;AAGA;IACI,iBAAiB;IACjB,cAAc;AAClB;;;;AAIA;IACI;QACI,mBAAmB;QACnB,iBAAiB;QACjB,sGAAsG;QACtG,YAAY;QACZ,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;QACpB,WAAW;QACX,kBAAkB;IACtB;AACJ;;AAEA;;uDAEuD;;AAEvD;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,sGAAsG;IACtG,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;;AAGA;IACI,iBAAiB;IACjB,cAAc;AAClB;;;;AAIA;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,iBAAiB;QACjB,sGAAsG;QACtG,YAAY;QACZ;IACJ;;IAEA;QACI,oBAAoB;QACpB,kBAAkB;QAClB,WAAW;QACX,kBAAkB;IACtB;;AAEJ;;;;;;AAMA;CACC,aAAa;AACd;;AAEA;IACI,wBAAwB;IACxB,WAAW;AACf;;AAEA;GACG,mBAAmB;AACtB;;AAEA;IACI,uBAAuB;;AAE3B;;;AAGA;;uDAEuD;;;AAGvD;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI;QACI,wCAAwC;QACxC,iBAAiB;QACjB,UAAU;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;;AAGA;IACI,kBAAkB;AACtB","sourcesContent":["\r\n#pai {\r\n    width: 94%;\r\n}\r\n/* ---------------------------------------------------\r\n    TABELA\r\n----------------------------------------------------- */\r\n\r\n.tabela {\r\n    overflow-y: scroll;\r\n    margin: 0 -15% 0% 4%;\r\n    height: 365px;\r\n    text-align: center;\r\n    width: 111%;\r\n \r\n}\r\n\r\nth {\r\n    position: sticky;\r\n    position: -webkit-sticky;\r\n    top: 0;\r\n    background: #007bff;\r\n    color:  white;\r\n}\r\n\r\n@media only screen and (max-width: 768px) {    \r\n    .tabela {\r\n        margin: 0 -15% 0% 3%;\r\n        width: 111%;\r\n    }\r\n\r\n\r\n\r\n\r\n}\r\n\r\n/* ---------------------------------------------------\r\n    CARD\r\n----------------------------------------------------- */\r\n\r\n\r\n\r\n.title-card {\r\n    font-weight: bold;\r\n    margin: 5% 0 5% 5%\r\n}\r\n\r\n.cardFornecedor {\r\n    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2PX rgba(0,0,0,0.20);\r\n    margin: 0 0% 5% 2%;\r\n    width: 110%;\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n    .title-card {\r\n        font-weight: bold;\r\n        margin: 5% 0 5% 5%\r\n    }\r\n    \r\n    .cardFornecedor {\r\n        width: 111%;\r\n        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2PX rgba(0,0,0,0.20);\r\n        margin: 0 0% 5% 3%;\r\n    }\r\n}\r\n\r\n/* ---------------------------------------------------\r\n    INPUTS\r\n----------------------------------------------------- */\r\n\r\n#data {\r\n    background-color: transparent;\r\n    border: none;\r\n    border-bottom: 1px solid black;\r\n    border-radius: 0;\r\n    outline: none;\r\n    height: 2rem;\r\n    width: 100%;\r\n    font-size: 1rem;\r\n    margin: 0 2% 0 15%;\r\n    padding: 0;\r\n    box-shadow: none;\r\n    box-sizing: content-box;\r\n    transition: all 0.3s;\r\n}\r\n\r\n#data1 {\r\n    background-color: transparent;\r\n    border: none;\r\n    border-bottom: 1px solid black;\r\n    border-radius: 0;\r\n    outline: none;\r\n    height: 2rem;\r\n    width: 100%;\r\n    font-size: 1rem;\r\n    margin: 0 2% 0 8%;\r\n    padding: 0;\r\n    box-shadow: none;\r\n    box-sizing: content-box;\r\n    transition: all 0.3s;\r\n}\r\n\r\n#dateInput {\r\n    width: 30%;\r\n}\r\n\r\n#dateInput1 {\r\n    width: 30%;\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n    #dateInput {\r\n        width: 50%;\r\n        padding-right: 0%;\r\n        margin-bottom: 4%;\r\n    }\r\n\r\n    #dateInput1 {\r\n        width: 50%;\r\n        padding-right: 0%;\r\n        margin-bottom: 4%;\r\n    }\r\n    \r\n    #data {\r\n        border-style: hidden hidden solid hidden;\r\n        width: 90%;\r\n        margin-left: 10%;\r\n        padding: 0%;\r\n        position: relative;\r\n    }\r\n    \r\n    #data1 {\r\n        border-style: hidden hidden solid hidden;\r\n        margin-left: 10%;\r\n        width: 90%;\r\n        padding: 0%;\r\n        position: relative;\r\n    }\r\n\r\n    #data1 .react-datepicker-ignore-onclickoutside .react-datepicker-popper {\r\n        left: -94px;\r\n        position: absolute;\r\n    }\r\n}\r\n\r\n\r\n/* ---------------------------------------------------\r\n    INPUTS POR CODIGO GERAL/POR ITEM GERAL\r\n----------------------------------------------------- */\r\n\r\n\r\n.revistaLabel {\r\n    margin: 0 0 0 7%;\r\n}\r\n\r\n#revista {\r\n    border-style: hidden hidden solid hidden;\r\n    border-radius: 0%;\r\n    width: 47%;\r\n    margin: 0 0 0 7%;\r\n    border-bottom: 1px solid black;\r\n    font-size: 2vh;\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n    .revistaLabel {\r\n        margin: 0 0 0 6%;\r\n    }\r\n    \r\n    #revista {\r\n        border-style: hidden hidden solid hidden;\r\n        border-radius: 0%;\r\n        width: 98%;\r\n        margin: 0 0 0 6%;\r\n    }\r\n}\r\n\r\n/* ---------------------------------------------------\r\n    INPUTS POR ITEM TAMANHOS\r\n----------------------------------------------------- */\r\n\r\n\r\n.revistaLabel2 {\r\n    margin: 0 2% 0 15%;\r\n}\r\n\r\n#revista2 {\r\n    border-style: hidden hidden solid hidden;\r\n    border-radius: 0%;\r\n    width: 100%;\r\n    margin: 0 0 0 15%;\r\n    border-bottom: 1px solid black;\r\n    font-size: 2vh;\r\n}\r\n\r\n.referenciaLabel2 {\r\n    margin: 2% 2% 0 10%;\r\n}\r\n\r\n#referencia2 {\r\n    border-style: hidden hidden solid hidden;\r\n    border-radius: 0%;\r\n    width: 100%;\r\n    margin: 0 0 0 8%;\r\n    border-bottom: 1px solid black;\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n    .revistaLabel2 {\r\n        margin: 0 2% 0 6%;\r\n    }\r\n    \r\n    #revista2 {\r\n        border-style: hidden hidden solid hidden;\r\n        border-radius: 0%;\r\n        width: 98%;\r\n        margin: 0 0 0 6%;\r\n    }\r\n    \r\n    .referenciaLabel2 {\r\n        margin: 0 0% 0 6%;\r\n    }\r\n    \r\n    #referencia2 {\r\n        border-style: hidden hidden solid hidden;\r\n        border-radius: 0%;\r\n        width: 98%;\r\n        margin: 0 0 0 6%;\r\n    }\r\n}\r\n\r\n/* ---------------------------------------------------\r\n    INPUTS POR ITEM LOJA\r\n----------------------------------------------------- */\r\n\r\n\r\n.revistaLabel3 {\r\n    margin: 0 2% 0 15%;\r\n}\r\n\r\n#revista3 {\r\n    border-style: hidden hidden solid hidden;\r\n    border-radius: 0%;\r\n    width: 100%;\r\n    margin: 0 0 0 15%;\r\n    border-bottom: 1px solid black;\r\n    font-size: 2vh;\r\n}\r\n\r\n.referenciaLabel3 {\r\n    margin: 2% 2% 0 10%;\r\n}\r\n\r\n#referencia3 {\r\n    border-style: hidden hidden solid hidden;\r\n    border-radius: 0%;\r\n    width: 100%;\r\n    margin: 0 0 0 8%;\r\n    border-bottom: 1px solid black;\r\n}\r\n\r\n\r\n@media only screen and (max-width: 768px) {\r\n    .revistaLabel3 {\r\n        margin: 0 2% 0 6%;\r\n    }\r\n    \r\n    #revista3 {\r\n        border-style: hidden hidden solid hidden;\r\n        border-radius: 0%;\r\n        width: 98%;\r\n        margin: 0 0 0 6%;\r\n    }\r\n    \r\n    .referenciaLabel3 {\r\n        margin: 0 0% 0 6%;\r\n    }\r\n    \r\n    #referencia3 {\r\n        border-style: hidden hidden solid hidden;\r\n        border-radius: 0%;\r\n        width: 98%;\r\n        margin: 0 0 0 6%;\r\n    }\r\n}\r\n\r\n/* ---------------------------------------------------\r\n    INPUTS ACUMULADO POR LOJA\r\n----------------------------------------------------- */\r\n\r\n\r\n.revistaLabel4 {\r\n    margin: 0 2% 0 15%;\r\n}\r\n\r\n#revista4 {\r\n    border-style: hidden hidden solid hidden;\r\n    border-radius: 0%;\r\n    width: 100%;\r\n    margin: 0 0 0 15%;\r\n    border-bottom: 1px solid black;\r\n    font-size: 2vh;\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n    .revistaLabel4 {\r\n        margin: 0 2% 0 6%;\r\n    }\r\n    \r\n    #revista4 {\r\n        border-style: hidden hidden solid hidden;\r\n        border-radius: 0%;\r\n        width: 98%;\r\n        margin: 0 0 0 6%;\r\n    }\r\n}\r\n\r\n/* ---------------------------------------------------\r\n    INPUTS POR CODIGO E LOJA\r\n----------------------------------------------------- */\r\n\r\n\r\n.revistaLabel5 {\r\n    margin: 0 2% 0 15%;\r\n}\r\n\r\n#revista5 {\r\n    border-style: hidden hidden solid hidden;\r\n    border-radius: 0%;\r\n    width: 100%;\r\n    margin: 0 0 0 15%;\r\n    border-bottom: 1px solid black;\r\n    font-size: 2vh;\r\n}\r\n\r\n.revistaLabel6 {\r\n    margin: 0 2% 0 10%;\r\n}\r\n\r\n#revista6 {\r\n    border-style: hidden hidden solid hidden;\r\n    border-radius: 0%;\r\n    width: 98%;\r\n    margin: 0 0 0 10%;\r\n    border-bottom: 1px solid black;\r\n    font-size: 2vh;\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n    .revistaLabel5 {\r\n        margin: 0 2% 0 6%;\r\n    }\r\n    \r\n    #revista5 {\r\n        border-style: hidden hidden solid hidden;\r\n        border-radius: 0%;\r\n        width: 98%;\r\n        margin: 0 0 0 6%;\r\n    }\r\n\r\n    .revistaLabel6 {\r\n        margin: 0 2% 0 6%;\r\n    }\r\n    \r\n    #revista6 {\r\n        border-style: hidden hidden solid hidden;\r\n        border-radius: 0%;\r\n        width: 98%;\r\n        margin: 0 0 0 6%;\r\n    }\r\n}\r\n\r\n/* ---------------------------------------------------\r\n    INPUTS POR CODIGO LOJA\r\n----------------------------------------------------- */\r\n\r\n\r\n.revistaLabel7 {\r\n    margin: 0 2% 0 15%;\r\n}\r\n\r\n#revista7 {\r\n    border-style: hidden hidden solid hidden;\r\n    border-radius: 0%;\r\n    width: 100%;\r\n    margin: 0 0 0 15%;\r\n    border-bottom: 1px solid black;\r\n    font-size: 2vh;\r\n}\r\n\r\n.revistaLabel8 {\r\n    margin: 0 2% 0 15%;\r\n}\r\n\r\n#revista8 {\r\n    border-style: hidden hidden solid hidden;\r\n    border-radius: 0%;\r\n    width: 100%;\r\n    margin: 0 0 0 10%;\r\n    border-bottom: 1px solid black;\r\n    font-size: 2vh;\r\n}\r\n\r\n.revistaLabel9 {\r\n    margin: 0 2% 0 15%;\r\n}\r\n\r\n#revista9 {\r\n    border-style: hidden hidden solid hidden;\r\n    border-radius: 0%;\r\n    width: 100%;\r\n    margin: 0 0 0 15%;\r\n    border-bottom: 1px solid black;\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n    .revistaLabel7 {\r\n        margin: 0 2% 0 6%;\r\n    }\r\n    \r\n    #revista7 {\r\n        border-style: hidden hidden solid hidden;\r\n        border-radius: 0%;\r\n        width: 98%;\r\n        margin: 0 0 0 6%;\r\n    }\r\n\r\n    .revistaLabel8 {\r\n        margin: 0 2% 0 6%;\r\n    }\r\n    \r\n    #revista8 {\r\n        border-style: hidden hidden solid hidden;\r\n        border-radius: 0%;\r\n        width: 98%;\r\n        margin: 0 0 0 6%;\r\n    }\r\n\r\n    .revistaLabel9 {\r\n        margin: 0 2% 0 6%;\r\n    }\r\n    \r\n    #revista9 {\r\n        border-style: hidden hidden solid hidden;\r\n        border-radius: 0%;\r\n        width: 98%;\r\n        margin: 0 0 0 6%;\r\n    }\r\n}\r\n\r\n/* ---------------------------------------------------\r\n    INPUTS POR CODIGO LOJA\r\n----------------------------------------------------- */\r\n\r\n\r\n.revistaLabel10 {\r\n    margin: 0 2% 0 15%;\r\n}\r\n\r\n#revista10 {\r\n    border-style: hidden hidden solid hidden;\r\n    border-radius: 0%;\r\n    width: 100%;\r\n    margin: 0 0 0 15%;\r\n    border-bottom: 1px solid black;\r\n    font-size: 2vh;\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n    .revistaLabel10 {\r\n        margin: 0 2% 0 6%;\r\n    }\r\n    \r\n    #revista10 {\r\n        border-style: hidden hidden solid hidden;\r\n        border-radius: 0%;\r\n        width: 98%;\r\n        margin: 0 0 0 6%;\r\n    }\r\n\r\n}\r\n\r\n/* ---------------------------------------------------\r\n    BUTTON LIMPAR\r\n----------------------------------------------------- */\r\n\r\ndiv .buttonLimpar {\r\n    position: relative;\r\n    margin: 0% 0% 0% 15%;\r\n    width: 100%;\r\n    position: relative;\r\n}\r\n\r\ndiv .buttonLimpar {\r\n    padding-top: 1%;\r\n    background:white;\r\n    border-radius: 0%;\r\n    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2);\r\n    border: none;     \r\n    color: #007bff;   \r\n}\r\n\r\n\r\ndiv .buttonLimpar:hover {\r\n    background: #007bff;\r\n    color:  white;\r\n}\r\n\r\ndiv .buttonLimpar:focus {\r\n    background: #007bff;\r\n    color: white;\r\n}\r\n\r\n\r\n@media only screen and (max-width: 768px) {\r\n    div .buttonLimpar {\r\n        padding: 0% 0% 0% 0%;\r\n        width: 100%;\r\n        position: relative;\r\n        margin:0% 0% 0% 5%;\r\n    }\r\n\r\n    div .buttonLimpar {\r\n        padding-top: 1%;\r\n        background: white;\r\n        border-radius: 0%;\r\n        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2);\r\n        border: none;\r\n        color: #007bff;   \r\n    }\r\n}\r\n\r\n/* ---------------------------------------------------\r\n    BUTTON FILTRAR\r\n----------------------------------------------------- */\r\n\r\ndiv .buttonFiltrar  {\r\n    padding: 0% 0% 2,5% 0%;\r\n    position: relative;\r\n    margin: 0% 0% 0% 15%;\r\n    width: 100%;\r\n}\r\n \r\n\r\ndiv .buttonFiltrar {\r\n    padding-top: 1%;\r\n    background: #007bff;\r\n    border-radius: 0%;\r\n    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2);\r\n    border: none;\t\r\n}\r\n\r\ndiv .buttonFiltrar:hover {\r\n    background: white;\r\n    color: #007bff;\r\n}\r\n\r\n\r\ndiv .buttonFiltrar:focus {\r\n    background: white;\r\n    color: #007bff;\r\n}\r\n\r\n\r\n\r\n@media only screen and (max-width: 768px) {\r\n    div .buttonFiltrar {\r\n        padding: 2% 0;\r\n        width: 102%;\r\n        position: relative;\r\n        margin:0% 0% 0% 5%;\r\n    }\r\n\r\n    div .buttonFiltrar {\r\n        padding-top: 1%;\r\n        background: #007bff;\r\n        border-radius: 0%;\r\n        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2); \r\n        border: none;\r\n    }\r\n}\r\n\r\n/* ---------------------------------------------------\r\n    BUTTON IMPRIMIR\r\n----------------------------------------------------- */\r\n\r\n.buttonImprimir {\r\n    padding: 0% 0% 0% 0%;\r\n    width: 100%;\r\n    margin: 0% 0% 0% 15%;\r\n    position: relative;\r\n}\r\n\r\n\r\n\r\ndiv .buttonImprimir {\r\n    padding-top: 1%;\r\n    background: #007bff;\r\n    border-radius: 0%;\r\n    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2);\r\n    border: none;\t\r\n    margin: 0% 0% 0% 8%;\r\n}\r\n\r\ndiv .buttonImprimir:hover {\r\n    background: white;\r\n    color: #007bff;\r\n}\r\n\r\n\r\ndiv .buttonImprimir:focus {\r\n    background: white;\r\n    color: #007bff;\r\n}\r\n\r\n\r\n\r\n@media only screen and (max-width: 768px) {\r\n    div .buttonImprimir {\r\n        background: #007bff;\r\n        border-radius: 0%;\r\n        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2); \r\n        border: none;\r\n        padding: 2% 0;\r\n        margin: 0% 0% 0% 5%;\r\n    }\r\n\r\n    .buttonImprimir {\r\n        padding: 0% 0% 0% 0%;\r\n        width: 102%;\r\n        position: relative;\r\n    }\r\n}\r\n\r\n/* ---------------------------------------------------\r\n    BUTTON BAIXAR\r\n----------------------------------------------------- */\r\n\r\n#test-table-xls-button {\r\n    padding: 4% 0%;\r\n    width: 100%;\r\n    position: relative;\r\n    margin:0% 2% 0% 15%;\r\n}\r\n\r\ndiv #test-table-xls-button {\r\n    padding-top: 1%;\r\n    background: #007bff;\r\n    color: white;\r\n    border-radius: 0%;\r\n    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2);\r\n    border: none;\t\r\n}\r\n\r\ndiv #test-table-xls-button:hover {\r\n    background: white;\r\n    color: #007bff;\r\n}\r\n\r\n\r\ndiv #test-table-xls-button:focus {\r\n    background: white;\r\n    color: #007bff;\r\n}\r\n\r\n\r\n\r\n@media only screen and (max-width: 768px) {\r\n    div #test-table-xls-button {\r\n        padding: 2% 0;\r\n        background: #007bff;\r\n        border-radius: 0%;\r\n        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2); \r\n        border: none;\r\n        color: white\r\n    }\r\n\r\n    #test-table-xls-button {\r\n        padding: 0% 0% 0% 0%;\r\n        margin:0% 0% 0% 5%;\r\n        width: 102%;\r\n        position: relative;\r\n    }\r\n    \r\n}\r\n\r\n\r\n\r\n\r\n\r\n.hide {\r\n display: none;\r\n}\r\n\r\n#formselect{\r\n    padding: 4px 4px 4px 4px;\r\n    width: 100%;\r\n}\r\n\r\n.enter{\r\n   margin: 5% 0% 0% 0%;\r\n}\r\n\r\n.centrocentro{\r\n    text-align-last: center;\r\n  \r\n}\r\n\r\n\r\n/* ---------------------------------------------------\r\n    Select Tabela\r\n----------------------------------------------------- */\r\n\r\n\r\n.labelSelect {\r\n    font-weight: bold;\r\n    font-size: 22px;\r\n}\r\n\r\n#select {\r\n    border-style: hidden hidden solid hidden;\r\n    border-radius: 0%;\r\n    width: 25%;\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n    #select {\r\n        border-style: hidden hidden solid hidden;\r\n        border-radius: 0%;\r\n        width: 80%;\r\n    }\r\n}\r\n\r\n.silas{\r\n    background: #007bff;\r\n    color: white;\r\n}\r\n\r\n\r\n.alinhamento{\r\n    text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
